<template>
    <div>
        <q-agent-licensing-sure-lc :agent="agent"
                                    v-if="tenantHasFeature('SureLC', agent.TenantID)"></q-agent-licensing-sure-lc>
    </div>
</template>
<script>

import QAgentLicensingSureLc from "@/components/utils/QAgentLicensingSureLc";

export default {
    name: "QAgentLicensing",
    props: ['agent'], // data passed to component from parent
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {

    },
    computed: {

    },
    methods: {

    },
    watch: {

    },
    components: {
        QAgentLicensingSureLc,
    }
}

</script>
<style scoped>
</style>
